export const FADE_IN_ANIMATION_DURATION = 700;
export const SLIDE_IN_ANIMATION_DURATION = 300;
